import axios from 'axios'

export const configAxios = axios.create({
  baseURL: process.env.VUE_APP_CONFIG_API_URL,
  headers: {
    'cache-control': 'max-age=0',
    'Pragma': 'no-cache',
    'Expires': '0',
  }
})
